var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { DocumentType, WidgetType, } from '@common/api';
import { createListItemsTagIdsFilter } from '@data/cell';
import { useCreateDocument, useDocumentsByParentId } from '@data/document/documentActions';
import { shownInKpis, shownInListItems, shownInModel } from '@data/exportConfiguration/exportConfiguration';
import { useExportConfigurations } from '@data/exportConfiguration/exportConfigurationActions';
import { useGrids } from '@data/grid/gridActions';
import { useUpdateUserSettingsActions } from '@data/hooks/currentUser';
import { useActiveYears } from '@data/hooks/timePoints';
import { useActiveVersions } from '@data/hooks/versions';
import { exportApi } from '@data/rest/api';
import { useTagContext } from '@data/tag/tagContext';
import { useCreateWidget } from '@data/widgets/widgetActions';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { ForecastProgressModal } from '@shared/finder/modals/ForecastModal';
import { ChevronDown, ChevronRight, Close, Dashboard, Download, Forecast, Plus, SheetRowCollapse, SheetRowUnCollapse, } from '@shared/icons/icons';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import Manager from '@shared/modal/Manager';
import { TextOverflowEllipsis } from '@styled/Basic';
import { FlexRow } from '@styled/FlexWrappers';
import { ModelToolbar, ModelToolbarButton } from '@styled/Model';
import { ListDocumentItem, ListFolderItem, PopoverContainer, PopoverContent, PopoverTitle } from '@styled/Popover';
import { KpiColumnOperation, KpiColumnType, ModelColumns, modelColumnsMeta, numberFormatTypesMeta, } from '@util/enums';
import { downloadFile } from '@util/helpers';
import React, { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { AiOutlineFunction, AiOutlineUnorderedList } from 'react-icons/ai';
import RelativePortal from 'react-relative-portal';
import { useNavigate } from 'react-router-dom';
import { useLocalData } from '../../base/LocalDataContext';
import { SheetRowPath } from '../../data/sheetRow/sheetRow';
import { useActionsBySheetRowId, useUpdateSheetRow } from '../../data/sheetRow/sheetRowActions';
import { useRootSheetRow, useSelectedSheetRow, useSheetRowBranch, useSheetRowsById, } from '../../data/sheetRow/sheetRowHooks';
import { isAccountTag } from '../../data/tag/types';
import ExportModelTableOptionsModal from '../../features/export/ExportModelTableOptionsModal';
import { useAuth } from '../../providers/AuthProvider';
import ExpressionToolbar from './ExpressionToolbar';
import ListItemsToolbar from './ListItemsToolbar';
import ToolbarSelect from './ToolbarSelect';
export default function FinanceToolbar(_a) {
    var _b, _c, _d, _e, _f;
    var modelTableData = _a.modelTableData;
    var activeVersions = useActiveVersions();
    var userSettings = useAuth().settings;
    var rootSheetRow = useRootSheetRow();
    var selectedSheetRow = useSelectedSheetRow();
    var actionsBySheetRowId = useActionsBySheetRowId().data;
    var tagData = useTagContext().tagData;
    var _g = useUpdateUserSettingsActions(), toggleListItemsShow = _g.toggleListItemsShow, toggleExpressionShow = _g.toggleExpressionShow, toggleVersion = _g.toggleVersion, setNumberFormatType = _g.setNumberFormatType, toggleModelStacked = _g.toggleModelStacked, toggleModelTableColumn = _g.toggleModelTableColumn, expandCollapseClusters = _g.expandCollapseClusters;
    var canUpdate = (_d = (_c = actionsBySheetRowId === null || actionsBySheetRowId === void 0 ? void 0 : actionsBySheetRowId[(_b = rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.id) !== null && _b !== void 0 ? _b : 0]) === null || _c === void 0 ? void 0 : _c.canUpdate) !== null && _d !== void 0 ? _d : false;
    var sheetRowAccountTag = tagData.tagById[(_f = (_e = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.variable) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : 0];
    return (React.createElement(ModelToolbar, null,
        React.createElement("div", null,
            React.createElement(ColumnsBox, { columns: userSettings.model_table_columns, toggleModelTableColumn: toggleModelTableColumn }),
            React.createElement(NumberFormatBox, { selectedType: userSettings.number_format_type, setNumberFormatType: setNumberFormatType }),
            React.createElement(VersionsBox, { selectedVersions: userSettings.model_table_filtered_versions, activeVersions: activeVersions, toggleVersion: toggleVersion }),
            React.createElement(OnlyWithData, { canEdit: canUpdate, selectedSheetRow: selectedSheetRow })),
        React.createElement("div", null,
            React.createElement(Stacked, { stacked: userSettings.model_table_stacked, toggle: toggleModelStacked }),
            React.createElement(Collapse, { expandCollapseClusters: expandCollapseClusters }),
            React.createElement(ModelTableExport, { rootSheetRow: rootSheetRow }),
            React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, onClick: function () {
                    return Manager.renderModal(React.createElement(ForecastProgressModal, { invalidateModelTable: modelTableData.invalidate }));
                } },
                React.createElement(Forecast, null)),
            React.createElement(CreateKPI, { rootSheetRow: rootSheetRow, columns: modelTableData.modelTable.columnHeaders })),
        React.createElement("div", { style: { flexGrow: 1, justifyContent: 'flex-end' } },
            userSettings.list_items_show && React.createElement(ListItemsToolbar, { canAdd: true }),
            React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, onClick: toggleListItemsShow },
                React.createElement(AiOutlineUnorderedList, { style: userSettings.list_items_show ? { color: 'green' } : {} })),
            React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, onClick: toggleExpressionShow, disabled: false },
                React.createElement(AiOutlineFunction, { style: userSettings.expression_show ? { color: 'green' } : {} }))),
        userSettings.expression_show && (React.createElement(ExpressionToolbar, { accountTag: isAccountTag(sheetRowAccountTag) ? sheetRowAccountTag : undefined, invalidateTable: modelTableData.invalidate }))));
}
function ColumnsBox(_a) {
    var columns = _a.columns, toggleModelTableColumn = _a.toggleModelTableColumn;
    var L = useLanguage().L;
    var action = function (column) {
        toggleModelTableColumn(column);
    };
    var options = modelColumnsMeta.map(function (i) { return ({ value: i.value, label: L(i.label) }); });
    return (React.createElement(ToolbarSelect, { selected: columns, action: action, options: options, label: L('Columns'), width: "max-content", multiselect: true }));
}
export function NumberFormatBox(_a) {
    var selectedType = _a.selectedType, setNumberFormatType = _a.setNumberFormatType;
    var L = useLanguage().L;
    var options = Object.entries(numberFormatTypesMeta).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], nf = _b[1];
        return ({ label: L(nf.label), value: key });
    });
    return (React.createElement(ToolbarSelect, { selected: selectedType, action: setNumberFormatType, options: options, label: L('Formatting'), width: "max-content" }));
}
export function VersionsBox(_a) {
    var selectedVersions = _a.selectedVersions, activeVersions = _a.activeVersions, toggleVersion = _a.toggleVersion;
    var L = useLanguage().L;
    var options = []; // [{ label: L('None'), value: 0 }];
    activeVersions.forEach(function (nf) {
        options.push({ label: nf.name, value: nf.id });
    });
    var handler = function (opt) {
        toggleVersion(opt);
    };
    return (React.createElement(ToolbarSelect, { selected: selectedVersions, action: function (opt) { return handler(opt); }, options: options, label: L('Versions'), width: "max-content", multiselect: true }));
}
function OnlyWithData(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f;
    var canEdit = _a.canEdit, selectedSheetRow = _a.selectedSheetRow;
    var L = useLanguage().L;
    var _g = useLocalData(), withDataMap = _g.withDataMap, setWithData = _g.setWithData;
    var update = useUpdateSheetRow();
    var parentId = (_b = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.sheetRow.parentId) !== null && _b !== void 0 ? _b : 0;
    var withData = (_e = (_d = (_c = withDataMap.get(parentId)) === null || _c === void 0 ? void 0 : _c.find(function (d) { return d.childId === (selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.sheetRow.id); })) === null || _d === void 0 ? void 0 : _d.withData) !== null && _e !== void 0 ? _e : selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.sheetRow.withData;
    var toggle = function () { return __awaiter(_this, void 0, void 0, function () {
        var copy;
        return __generator(this, function (_a) {
            if (!selectedSheetRow) {
                return [2 /*return*/];
            }
            copy = __assign(__assign({}, selectedSheetRow.sheetRow), { withData: !selectedSheetRow.sheetRow.withData });
            if (canEdit) {
                update.mutate(copy);
            }
            setWithData(parentId, selectedSheetRow.id, !withData);
            return [2 /*return*/];
        });
    }); };
    var disabled = !((_f = selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.sheetRow) === null || _f === void 0 ? void 0 : _f.tableTagId);
    return (React.createElement(ModelToolbarButton, { disabled: disabled, onClick: toggle, style: withData ? { color: '#3b85ff' } : {} }, L('Only With data')));
}
export function Stacked(_a) {
    var stacked = _a.stacked, toggle = _a.toggle;
    var L = useLanguage().L;
    return (React.createElement(ModelToolbarButton, { onClick: toggle, style: __assign(__assign({}, (stacked ? { color: '#3b85ff' } : {})), { borderLeft: 'none' }) }, L('Stacked')));
}
function ModelTableExport(_a) {
    var _this = this;
    var _b;
    var rootSheetRow = _a.rootSheetRow;
    var L = useLanguage().L;
    var exportConfigurations = useExportConfigurations();
    var activeVersions = useActiveVersions();
    var activeYears = useActiveYears();
    var userSettings = useAuth().settings;
    var selectedSheetRow = useSelectedSheetRow();
    var currentExportConfigurationList = (_b = exportConfigurations.data) === null || _b === void 0 ? void 0 : _b.filter(userSettings.list_items_show ? shownInListItems : shownInModel);
    var tagData = useTagContext().tagData;
    var filterTagIds = useLocalData().filterTagIds;
    function exportListItems(exportConfigurationId) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, exportApi.exportCells(exportConfigurationId, {
                            tagIdsFilters: (_a = createListItemsTagIdsFilter({
                                activeVersions: activeVersions,
                                activeYears: activeYears,
                                internalTagsMap: tagData.internalTagsMap,
                                selectedSheetRow: selectedSheetRow,
                                tagByIdMap: tagData.tagById,
                                userSettings: userSettings,
                            })) !== null && _a !== void 0 ? _a : [],
                        })];
                    case 1:
                        blob = _b.sent();
                        downloadFile(blob, 'ListItems.xlsx');
                        return [2 /*return*/];
                }
            });
        });
    }
    function exportModelData(exportConfigurationId) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                Manager.renderModal(React.createElement(ExportModelTableOptionsModal, { path: (_a = rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.path) !== null && _a !== void 0 ? _a : '0', filename: 'Sheet.xlsx', filterDimensionIds: filterTagIds, exportConfigurationId: exportConfigurationId }));
                return [2 /*return*/];
            });
        });
    }
    var exportTableData = function (exportConfigurationId) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!userSettings.list_items_show) {
                        exportModelData(exportConfigurationId);
                        return [2 /*return*/];
                    }
                    startGlobalLoading();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, exportListItems(exportConfigurationId)];
                case 2:
                    _a.sent();
                    toast.success(L('File downloaded'));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    toast.error(L('Failed to export from given configuration'));
                    console.error(error_1.message);
                    console.error(error_1.stack);
                    return [3 /*break*/, 5];
                case 4:
                    stopGlobalLoading();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, onClick: function () {
            var _a;
            var exportConfigurationId = (_a = currentExportConfigurationList === null || currentExportConfigurationList === void 0 ? void 0 : currentExportConfigurationList[0]) === null || _a === void 0 ? void 0 : _a.id;
            exportConfigurationId && exportTableData(exportConfigurationId);
        } },
        React.createElement(Download, null)));
}
var maxExpandedLength = 1000;
export function Collapse(_a) {
    var _this = this;
    var _b;
    var expandCollapseClusters = _a.expandCollapseClusters;
    var settings = useAuth().settings;
    var rootRow = useRootSheetRow();
    var sheetRowsById = useSheetRowsById();
    var tagData = useTagContext().tagData;
    var selectedRootPath = new SheetRowPath((_b = rootRow === null || rootRow === void 0 ? void 0 : rootRow.path) !== null && _b !== void 0 ? _b : '0');
    var _c = __read(useSheetRowBranch(selectedRootPath, tagData.tagById, sheetRowsById, settings.expanded_clusters), 1), rows = _c[0];
    var collapseLevelHandler = function (expand) { return __awaiter(_this, void 0, void 0, function () {
        var expanded, childrenPaths, rows_1, rows_1_1, row, filtered, filtered;
        var e_1, _a;
        return __generator(this, function (_b) {
            expanded = settings.expanded_clusters;
            if (expand) {
                childrenPaths = [];
                try {
                    for (rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                        row = rows_1_1.value;
                        if (!expanded.includes(row.path)) {
                            childrenPaths.push(row.path);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (childrenPaths.length + expanded.length <= maxExpandedLength) {
                    expandCollapseClusters(__spreadArray(__spreadArray([], __read(expanded), false), __read(childrenPaths), false));
                }
                else if (childrenPaths.length <= maxExpandedLength) {
                    filtered = settings.expanded_clusters.filter(function (exp) {
                        return exp.startsWith("".concat(selectedRootPath.toString()));
                    });
                    if (filtered.length + childrenPaths.length <= maxExpandedLength) {
                        expandCollapseClusters(__spreadArray(__spreadArray([], __read(filtered), false), __read(childrenPaths), false));
                        toast.success('Closed not displayed rows to open these.');
                    }
                    else {
                        expandCollapseClusters(__spreadArray(__spreadArray([], __read(filtered), false), __read(childrenPaths), false).slice(0, maxExpandedLength));
                        toast.success('Closed not displayed rows to open as much of these as possible.');
                    }
                }
            }
            else {
                filtered = settings.expanded_clusters.filter(function (exp) { return !exp.startsWith("".concat(selectedRootPath.toString())); });
                expandCollapseClusters(filtered);
            }
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, style: { padding: '0 10px' }, onClick: function () { return collapseLevelHandler(false); } },
            React.createElement(SheetRowCollapse, null)),
        React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, style: { padding: '0 10px' }, onClick: function () { return collapseLevelHandler(true); } },
            React.createElement(SheetRowUnCollapse, null))));
}
export function CreateKPI(_a) {
    var _this = this;
    var _b;
    var rootSheetRow = _a.rootSheetRow, columns = _a.columns;
    var navigate = useNavigate();
    var L = useLanguage().L;
    var grids = useGrids();
    var docsByParentId = useDocumentsByParentId();
    var exportConfigurations = useExportConfigurations();
    var createWidget = useCreateWidget();
    var createDocument = useCreateDocument();
    var buttonRef = useRef(null);
    var _c = __read(useState(false), 2), showPopover = _c[0], setShowPopover = _c[1];
    var btn = (_b = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    var btnWidth = btn ? btn.width : 0;
    var maxHeight = btn ? window.innerHeight - btn.bottom : 0;
    var _d = __read(useState([]), 2), collapsed = _d[0], setCollapsed = _d[1];
    var folders = docsByParentId[0];
    var addKpi = function (docId) { return __awaiter(_this, void 0, void 0, function () {
        var kpiCols, defaultKpi, newKPI, currentGrid;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!rootSheetRow) {
                        return [2 /*return*/];
                    }
                    kpiCols = [];
                    columns.forEach(function (col, idx) {
                        var _a, _b;
                        if (col.type === ModelColumns.MONTH ||
                            col.type === ModelColumns.QUARTER ||
                            col.type === ModelColumns.HALFYEAR ||
                            col.type === ModelColumns.YEAR ||
                            col.type === ModelColumns.YEAR_TO_DATE ||
                            col.type === ModelColumns.SUM ||
                            col.type === ModelColumns.CUSTOM_COL) {
                            kpiCols.push({
                                id: "sheet-col-".concat(idx),
                                type: KpiColumnType.SELECTOR,
                                title: col.title,
                                hide: false,
                                tags: col.dataString.replace('tags(', '').replace(')', '').split(',').map(Number),
                            });
                        }
                        else if (col.type === ModelColumns.COMPARISON) {
                            var dataStringA_1 = '';
                            var dataStringB_1 = '';
                            var operation = KpiColumnOperation.MINUS;
                            if (col.dataString.startsWith('100*(tags')) {
                                var pattern = "(?<=100\\*\\()(.*)(?=\\)\\/tags)";
                                var result = col.dataString.match(pattern);
                                var dataStrings = result ? result[1] : '';
                                _a = __read(dataStrings.split('-'), 2), dataStringA_1 = _a[0], dataStringB_1 = _a[1];
                                operation = KpiColumnOperation.DIFF_PERCENT;
                            }
                            else {
                                _b = __read(col.dataString.split('-'), 2), dataStringA_1 = _b[0], dataStringB_1 = _b[1];
                                operation = KpiColumnOperation.MINUS;
                            }
                            var opA = columns.findIndex(function (col) { return col.dataString === dataStringA_1; });
                            var opB = columns.findIndex(function (col) { return col.dataString === dataStringB_1; });
                            if (opA && opB) {
                                kpiCols.push({
                                    hide: false,
                                    id: "sheet-comparison-col-".concat(idx),
                                    opA: "sheet-col-".concat(opA),
                                    opB: "sheet-col-".concat(opB),
                                    operation: operation,
                                    title: col.title,
                                    type: KpiColumnType.DIFF,
                                });
                            }
                        }
                    });
                    defaultKpi = (_b = (_a = exportConfigurations === null || exportConfigurations === void 0 ? void 0 : exportConfigurations.data) === null || _a === void 0 ? void 0 : _a.filter(shownInKpis)) === null || _b === void 0 ? void 0 : _b[0];
                    newKPI = {
                        title: '',
                        type: WidgetType.KPI,
                        config: JSON.stringify(__assign(__assign({}, parseWidgetConfig(null, WidgetType.KPI)), { exportConfigurationId: defaultKpi === null || defaultKpi === void 0 ? void 0 : defaultKpi.id, kpiCols: kpiCols, path: rootSheetRow.path })),
                        GridId: 0,
                    };
                    if (!docId) return [3 /*break*/, 2];
                    currentGrid = (_c = grids.data) === null || _c === void 0 ? void 0 : _c.find(function (g) { return g.DocumentId === docId; });
                    if (!currentGrid) {
                        return [2 /*return*/];
                    }
                    newKPI.GridId = currentGrid.id;
                    return [4 /*yield*/, createWidget.mutateAsync(newKPI)];
                case 1:
                    _d.sent();
                    navigate("/dashboard/".concat(docId));
                    _d.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var createDocumentHanlder = function (folderId) {
        var newDoc = {
            title: 'New Report',
            description: '',
            ParentId: folderId,
            config: '{}',
            type: DocumentType.REPORT,
            gridLocked: false,
        };
        createDocument.mutateAsync(newDoc);
        if (collapsed.includes(folderId)) {
            collapsedToggle(folderId);
        }
    };
    var collapsedToggle = function (folerId) {
        var newCollapsed = __spreadArray([], __read(collapsed), false);
        if (collapsed.includes(folerId)) {
            newCollapsed = newCollapsed.filter(function (val) { return val !== folerId; });
        }
        else {
            newCollapsed.push(folerId);
        }
        setCollapsed(newCollapsed);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModelToolbarButton, { ref: buttonRef, "$isOnlyIcon": true, onClick: function (e) { return (showPopover ? setShowPopover(false) : setShowPopover(true)); } },
            React.createElement(Dashboard, null)),
        React.createElement(RelativePortal, { component: "div", left: -btnWidth, top: 45, onOutClick: function () { return (showPopover ? setShowPopover(false) : undefined); } }, showPopover ? (React.createElement(PopoverContainer, { className: "tiny-scrollbars", style: { maxHeight: maxHeight - 20 } },
            React.createElement(PopoverTitle, null,
                L('Add to Dashboard'),
                React.createElement("div", { className: "close-btn", onClick: function () { return setShowPopover(false); } },
                    React.createElement(Close, null))),
            React.createElement(PopoverContent, null, folders === null || folders === void 0 ? void 0 : folders.map(function (folder) {
                var docs = docsByParentId[folder.id];
                var isOpen = !collapsed.includes(folder.id);
                return (React.createElement("div", { key: "folder-".concat(folder.id) },
                    React.createElement(ListFolderItem, null,
                        React.createElement(FlexRow, { style: { alignItems: 'center', overflow: 'hidden' } },
                            React.createElement("div", { className: "collapse-btn", onClick: function () { return collapsedToggle(folder.id); } }, isOpen ? (React.createElement(ChevronDown, { width: 22, height: 22 })) : (React.createElement(ChevronRight, { width: 22, height: 22 }))),
                            React.createElement(TextOverflowEllipsis, null, folder.title)),
                        React.createElement("div", { className: "icon-btn", onClick: function () { return createDocumentHanlder(folder.id); } },
                            React.createElement(Plus, null))),
                    isOpen &&
                        (docs === null || docs === void 0 ? void 0 : docs.map(function (doc) {
                            return (React.createElement(ListDocumentItem, { key: "doc-".concat(doc.id), onClick: function () { return addKpi(doc.id); } },
                                React.createElement(TextOverflowEllipsis, null, doc.title)));
                        }))));
            })))) : null)));
}
